import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import { defaultTo, path } from 'ramda';
import Select from 'react-select';

import styles from './styles.m.scss';

import { handleError, handleSuccess } from '../../../../../util/forms';
import { apiUpdateRegistration } from '../../../../../api/registration';

import Footer from '../../../../../components/Accordion/Footer';
import EditField from '../../../../../components/Forms/EditField';
import Radio from '../../../../../components/Forms/Radio';

const propTypes = {
  updateRegistration: PropTypes.func,
  setStep: PropTypes.func,
  step: PropTypes.number,
  universities: PropTypes.array,
};

const UniversityInformation = ({
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  isValid,
  step,
  setStep,
  setFieldValue,
  universities,
  values,
  registration,
}) => (
  <form>
    <h2 className={styles.stepHeader}>
      Please provide us some information about the {path(['pathway', 'name'], registration)} in which you are enrolled.
    </h2>
    <EditField
      as={Select}
      bare
      simpleValue
      name="universityProgramId"
      label="Institution"
      onChange={(value) => setFieldValue('universityProgramId', value)}
      options={universities.map((university) => ({ value: university.id, label: university.name }))}
      value={values.universityProgramId}
    />
    <EditField
      name="universityProgramDepartment"
      label="Department / School"
      value={values.universityProgramDepartment}
      onBlur={handleBlur}
      onChange={handleChange}
    />
    <div className="form-group row">
      <label className="col-md-3 col-form-label">Level of Study</label>
      <div className="col-md-7">
        <Radio
          name="universityProgramLevelOfStudy"
          label="Undergraduate"
          value="Undergraduate"
          checked={values.universityProgramLevelOfStudy}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        <Radio
          name="universityProgramLevelOfStudy"
          label="Graduate"
          value="Graduate"
          checked={values.universityProgramLevelOfStudy}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        <Radio
          name="universityProgramLevelOfStudy"
          label="PhD"
          value="PhD"
          checked={values.universityProgramLevelOfStudy}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        <Radio
          name="universityProgramLevelOfStudy"
          label="Distance Learning"
          value="Distance Learning"
          checked={values.universityProgramLevelOfStudy}
          onBlur={handleBlur}
          onChange={handleChange}
        />
      </div>
    </div>
    <EditField
      name="universityProgramMajor"
      label="Major"
      value={values.universityProgramMajor}
      onBlur={handleBlur}
      onChange={handleChange}
    />
    <Footer step={step} setStep={setStep} isValid={isValid} isSubmitting={isSubmitting} handleSubmit={handleSubmit} />
  </form>
);

UniversityInformation.propTypes = propTypes;

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiUpdateRegistration(props.registration.id, { stepName: props.name, ...payload })
      .then(({ data }) => props.updateRegistration(data))
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ registration }) => ({
    universityProgramId: defaultTo('', registration.universityProgramId),
    universityProgramDepartment: defaultTo('', registration.universityProgramDepartment),
    universityProgramLevelOfStudy: defaultTo('', registration.universityProgramLevelOfStudy),
    universityProgramMajor: defaultTo('', registration.universityProgramMajor),
  }),
  isInitialValid: true,
  validateOnChange: true,
})(UniversityInformation);
